import React, { Component } from 'react';
import { withRouter } from 'react-router';

/* import Axios library */
import Axios from 'axios';

/* import the different search forms and the modal to use */
import SearchFormRJR from './searchForm_rjr';
import SearchFormLorillard from './searchForm_lorillard';
import SearchFormBW from './searchForm_bw';
import SearchFormATCO from './searchForm_atco';
import SearchFormAllCollections from './searchForm_allCollections';
import RJRModal from '../shared/modal';
import SearchFormModalContent from './components/searchFormModalContent';

class SearchForm extends Component {

    constructor(props) {
        super(props);
        
        /* in the searchForm state, form brand is the first part of the URL (rjr, atco, etc.). 
        Form type is the second part of the URL (public, confidential, etc.) */
        this.state = {
            formBrand: this.props.match.params.formBrand,
            formType: this.props.match.params.formType,
            showModal: false,
            modalData: {},
            modalTitle: 'RJ Reynolds Public Document Repository:'
        }
    }

    componentWillReceiveProps(newProps) {
        this.setState({
            formBrand: newProps.match.params.formBrand,
            formType: newProps.match.params.formType
        });
    }

    //this is a shared function across the forms. When you click on a field label, we get the description of that field
    //from a JSON file and then display it in a modal. Once we set the showModal state value to true, that's what actually
    //shows the modal
    loadModalFieldData = labelClicked => {

        //get the JSON file via AJAX. This is located in the public folder so will be in the final build
        //but doesn't get compiled with all the other JS
        Axios.get(process.env.PUBLIC_URL + '/static/fieldDescriptions.json')
        .then((response) => {

        //data comes through as array of objects
        let labelData = response.data.filter(item => {
            return item.Title === labelClicked;
        });

        let modalContentComp;

        //instantiate a new modal content component and spread the props
        if (labelData.length === 1) {
            modalContentComp = <SearchFormModalContent {...labelData[0]} />
        } else {
            //if no match or multiple matches, just blank out the data, since
            //there's no way to tell what label data we should show
            modalContentComp = <SearchFormModalContent 
                Title="Could not find details"
                Description="Could not find details"
                Format="Could not find details"
                Example="Could not find details"
                RequiredByUSDOJOrder="Could not find details"               
            />
        }

        //only set props and show modal if there's a single match.  
        this.setState({modalContent: modalContentComp, showModal:true});        

        })
        .catch((error) => {
            //this will show an error in the modal if it absolutely can't
            //load the modal content (if multiple results, that's handled above)
            //if any of the search URLs throw an error, the whole thing is treated as an error
            //stateless functional component here just for the search results error modal 
            const ModalErrorContent = () => <div><h4>ERROR: Could not load field details</h4></div>;

            //only set props and show modal if there's a single match.  
            this.setState({modalContent: <ModalErrorContent/>, showModal:true});  
        });
    }

    handleToggleModal() {
        this.setState({ showModal: !this.state.showModal });
    }

    goToSearchResults = (queryString) => {
        this.props.history.push({
            pathname: `${this.state.formType}/searchResults`,
            state: {queryString: queryString, formBrand: this.state.formBrand, formType: this.state.formType}
        });    
    }

    render() {
        return (
            <div>
                { (this.state.formBrand === 'rjr') ? <SearchFormRJR modalHandler={this.loadModalFieldData} searchRequestHandler={this.goToSearchResults.bind(this)} headerTitle="RJRT" formType="public" formBrand={this.state.formBrand} /> : null}
                { (this.state.formBrand === 'bw') ? <SearchFormBW modalHandler={this.loadModalFieldData} searchRequestHandler={this.goToSearchResults.bind(this)} headerTitle="B&W" formType="public" formBrand={this.state.formBrand} /> : null}
                { (this.state.formBrand === 'atco') ? <SearchFormATCO modalHandler={this.loadModalFieldData} searchRequestHandler={this.goToSearchResults.bind(this)} headerTitle="ATCO" formType="public" formBrand={this.state.formBrand} /> : null}
                { (this.state.formBrand === 'lorillard') ? <SearchFormLorillard modalHandler={this.loadModalFieldData} searchRequestHandler={this.goToSearchResults.bind(this)} headerTitle="Lorillard" formType="public" formBrand={this.state.formBrand} /> : null}
                { (this.state.formBrand === 'allCollections') ? <SearchFormAllCollections modalHandler={this.loadModalFieldData} searchRequestHandler={this.goToSearchResults.bind(this)} headerTitle="" formType="public" formBrand={this.state.formBrand} /> : null}
                <RJRModal modalContent={this.state.modalContent}  title={this.state.modalTitle} showModal={this.state.showModal } onCloseRequest={() => this.handleToggleModal()} />
            </div>
        );
    }
}

export default withRouter(SearchForm);


// WEBPACK FOOTER //
// ./src/components/searchForm/searchForm.js